export default {
  isTimerActive: (state) => state.tracker.isTimerActive,
  elapsedTime: (state) => state.tracker.elapsedTime,
  elapsedTimeOnlySeconds: (state) => state.tracker.elapsedTimeOnlySeconds,
  selectedTakeaway: (state) => state.tracker.selectedTakeaway,
  isPaused: (state) => state.tracker.isPaused
};
